<template>
    <div>
        <div v-if="entry.title">
            <h3>{{ entry.title }}</h3>
            <div v-html="entry.text"></div>
        </div>
        <v-list v-if="entry.children.length">
            <v-list-item v-for="entry in entry.children" :key="entry.title" @click="$emit('click', entry)">
                <v-list-item-content class="icon-arrow-down">
                    <v-list-item-title>{{ entry.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
  export default {
    props: {
      entry: {
        type: [Array, Object],
        required: true
      },
      parentChain: {
        type: Array
      }
    }
  }
</script>

<style scoped>

</style>
